var routes = require('./routes');

module.exports = {
    cdnPath: "https://qmperfcdn.gaf.com",
    cdnBuildPath: 'https://qmperfcdn.gaf.com/',
    siteUrl: 'https://quickmeasureperf.gaf.com',
    reportUrl: 'https://quickmeasureapiperf.gaf.com/api/v1.0/roofmeasure/download',
    baseUrl: 'https://quickmeasureapiperf.gaf.com/api/v1.0',
    oktaLogoutUrl: 'https://standardindustries.okta-emea.com/login/signout?fromURI=https://quickmeasureperf.gaf.com',
    oktaErrorLogoutUrl: 'https://ssoextperf.gaf.com/login/signout?fromURI=https://standardindustries.okta-emea.com/login/signout',
    gafLoginArray: ['gaf.com', 'gaf.energy'],
    googleMapUrl: 'https://maps.googleapis.com/maps/api/js?libraries=places&callback=Function.prototype&key=',
    googleMapKey: 'AIzaSyDOAXKZbnd2xOiL8UVbwkd0IucR6wOaaZ0',
    googleTrackingId: 'GTM-PT8DZ8F',
    newGoogleTrackingId: '',
    instrumentationKey: '38e5543a-57e1-4a5e-90cf-f3d4686bc97c',
    isAppInsightEnabled: true,
    isTrackTraceEnabled: true,
    appIdleTimeOut: 1000 * 60 * 59,
    termsAndConditionUrl: 'https://www.gaf.com/en-us/document-library/documents/documents/legaldocumentsdocuments/GAF_QuickMeasure_Roof_Report_Terms_and_Conditions.pdf',
    privacyPolicyUrl: 'https://www.gaf.com/en-us/our-company/privacy-and-legal/privacy-policy',
    gafEnergyPrivacyPolicyUrl: 'https://www.gaf.energy/privacy-policy/',
    rewardsURL: 'https://rewardsuat.gaf.com/signup?directfrom=quickmeasurelp',
    pdReceiptUrl: 'https://payperf.gaf.com',
    sampleReport: "https://www.gaf.com/en-us/document-library/documents/documents/formsdocuments/reportsdocuments/QuickMeasure_Roof_Report_Sample.pdf",
    companyInformationPageUrl: 'https://cczperf.gaf.com',
    errorEmailNotification: 'qmperfnotifications@gaf.com',
    guestUserEmail: "guest@gaf.com",
    routes: routes,
    maxPinAllowed: 10,
    replenishMinCustomAmt: 1,
    replenishMaxCustomAmt: 20000,
    replenishMinBalance: 25,
    managePaymentPageUrl: 'https://payperf.gaf.com/managepaymentmethods/QuickMeasure',
    shouldLoadProBundle: false,
    defaultBundleForCoverageMap: 'QM',
    reSubmitFromDate: '2022-12-13',
    quickCartURL: 'https://staging.quickcart.com',
    maxRedeemCodeAttempt: 3,


    // For okta
    clientId: '0oaqh51fzsGCd7nL00h7',
    issuer: 'https://ssoextperf.gaf.com/oauth2/ausqh4jklmuGrL2qx0h7',
    loginUrl: "https://quickmeasureperf.gaf.com",
    // postLogoutRedirectUri: "https://ssoperf.gaf.com/v2/logout?client_id=IKsB87kvmb9NKoI6TmOvW4hF7Quq5zve&returnTo=https://www.gaf.com/en-us/quickmeasure",
    postLogoutRedirectUri: 'https://www.gaf.com/en-us/quickmeasure',
    redirectUri: "https://quickmeasureperf.gaf.com/callback",
    // Auth0idp: "0oapxomiyexkk2qj80h7",
    // Oktaidp: "0oapmctzfbnZnQmgo0h7"
    Report3DUrl: "https://eave-frontend-staging.appspot.com/report?taskId=",


    // Recaptcha
    sitekey: '6LdZleYZAAAAAPJ9L6C-kmTob4C9EGcuvK-wpj-A'

}
